export default __webpack_public_path__ + "static/media/newExportIcon.35611980.svg";